import React, { useMemo } from "react";
import { Box, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import DynamicFormOutlinedIcon from "@mui/icons-material/DynamicFormOutlined";
import { formatMessageTime } from "./conversationUtils";
import "./ArtifactToolCard.css";

const artifactEventSurfaceSx = (theme) => ({
  "--artifact-event-border": alpha(theme.palette.info.main, theme.palette.mode === "dark" ? 0.32 : 0.28),
  "--artifact-event-bg": alpha(theme.palette.info.main, theme.palette.mode === "dark" ? 0.09 : 0.06),
});

function parseEvent(content) {
  if (!content) return null;
  if (typeof content === "object") return content;
  try {
    return JSON.parse(content);
  } catch {
    return null;
  }
}

export default function ArtifactEventMessage({ content, timestamp }) {
  const parsed = useMemo(() => parseEvent(content), [content]);
  const title = parsed?.title || "Artifact";
  const eventName = parsed?.eventName || "event";
  const payload = parsed?.payload && typeof parsed.payload === "object" ? parsed.payload : {};
  const payloadText = JSON.stringify(payload, null, 2);

  return (
    <Box className="artifact-event-message">
      <Box className="artifact-event-message-surface" sx={artifactEventSurfaceSx}>
        <Box className="artifact-event-message-header">
          <DynamicFormOutlinedIcon sx={{ fontSize: 16, color: "primary.main", flexShrink: 0 }} />
          <Typography sx={{ fontSize: "12px", fontWeight: 700, color: "text.primary", flex: 1 }}>
            Artifact &quot;{title}&quot; emitted &quot;{eventName}&quot;
          </Typography>
          {timestamp && (
            <Typography sx={{ fontSize: "11px", color: "text.secondary", whiteSpace: "nowrap" }}>
              {formatMessageTime(timestamp)}
            </Typography>
          )}
        </Box>
        <Box className="artifact-event-message-payload">
          <Typography sx={{ fontSize: "11px", fontWeight: 700, color: "text.secondary", mb: 0.5 }}>
            Payload
          </Typography>
          <Typography
            component="pre"
            sx={{
              m: 0,
              fontSize: "12px",
              fontFamily: "monospace",
              color: "text.primary",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
            }}
          >
            {payloadText}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
